import app from '@/main'

export function resolveVueRouterAndOpenNewTab(obj) {
  const urlObj = app.$router.resolve(obj)

  if (urlObj && urlObj.href) {
    window.open(urlObj.href)
  } else {
    app.$message.error('跳转页面地址解析失败')
  }
}

export function resolveVueRouter(obj) {
  const urlObj = app.$router.resolve(obj)

  if (urlObj && urlObj.href) {
    return urlObj.href
  } else {
    return ''
  }
}
